export default "__VITE_ASSET__Cll89BrJ__"